/* eslint-disable max-len, no-console */
import { encodeBase64 } from 'Helpers/encoding';
import { extractCSS } from 'Helpers/Dom';

// generatePreview creates an html string of a document, the body of which includes the content
// of the first element in the current document that matches the provided class name. Optionally,
// a preprocessing function may be provided that manipulates the html string before it is returned.
// A good example of a preprocessing function is using a regex to remove the left nav when
// generating a preview of the client blueprint.
// preprocessor must be a function that accepts a string and returns a string.
export const generatePreview = (className, preprocessor) => new Promise((resolve, reject) => {
  // set the preprocessor to the identity function if it isn't provided
  if (typeof preprocessor !== 'function') {
      preprocessor = str => str; // eslint-disable-line
  }

  // select all elements that match the class name
  const elements = document.getElementsByClassName(className);

  if (elements.length === 0) {
    resolve(preprocessor(''));
  }

  // select the first element with the matching class name and get the html
  const content = elements[0].outerHTML;

  extractCSS(document)
    .then(styles => resolve(
      preprocessor(`
      <style type="text/css">
          ${styles}
      </style>
      ${content}
    `),
    ))
    .catch((err) => {
      reject(err);
    });
});

// generateBase64EncodedPreview does the same as generatePreview, but base64 encodes the html string
// export const generateBase64EncodedPreview = (className, preprocessor) => encodeBase64(generatePreview(className, preprocessor));
export const generateBase64EncodedPreview = (className, preprocessor) => generatePreview(className, preprocessor)
  .then(preview => Promise.resolve(encodeBase64(preview)))
  .catch(err => Promise.reject(err));
